// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getIsPunchOutSession, getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React from "react";
import { connect } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        isAuthenticated: getSession(state).isAuthenticated,
        fulfillmentMethod: state.components.addressDrawer.fulfillmentMethod,
        isPunchOutSession: getIsPunchOutSession(state),
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasShellContext;

interface AddressDrawerContainerStyles {
    drawerContainer?: GridContainerProps;
    punchOutAddressGridItem?: GridItemProps;
    fulfillmentMethodGridItem?: GridItemProps;
    addressesGridItem?: GridItemProps;
    addressesGridItemAnonymousUser?: GridItemProps;
    pickUpAddressGridItem?: GridItemProps;
    pickUpAddressGridItemAnonymousUser?: GridItemProps;
    applyButtonGridItem?: GridItemProps;
}

export const addressDrawerContainerStyles: AddressDrawerContainerStyles = {};

const styles = addressDrawerContainerStyles;

// XNG-Change: some changes on structure
const AddressDrawerContainer = ({ id, isAuthenticated, fulfillmentMethod, isPunchOutSession, shellContext }: Props) => {
    return (
        <>
            {(isPunchOutSession || shellContext.isEditing) && (
                <GridContainer {...styles.drawerContainer}>
                    <GridItem {...styles.punchOutAddressGridItem}>
                        <Zone zoneName="PunchOutAddress" contentId={id} />
                    </GridItem>
                </GridContainer>
            )}
            {(!isPunchOutSession || shellContext.isEditing) && (
                <GridContainer {...styles.drawerContainer}>
                    <GridItem {...styles.fulfillmentMethodGridItem}>
                        <Zone zoneName="FulfillmentMethod" contentId={id} />
                        <Zone zoneName="PickUpAddress" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.addressesGridItem}>
                        <Zone zoneName="Addresses" contentId={id} />
                        <Zone zoneName="ApplyButton" contentId={id} />
                    </GridItem>
                </GridContainer>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withIsInShell(AddressDrawerContainer)),
    definition: {
        group: "Header",
        icon: "house",
    },
};

export default widgetModule;
